import { Head } from '@inertiajs/react';

function Seo({ metaTags }) {
    return metaTags ? (
        <Head>
            {metaTags.title && <title>{metaTags.title}</title>}
            {metaTags.title && <meta property='og:title' content={metaTags.title} />}
            {metaTags.title && <meta name='twitter:title' content={metaTags.title} />}
            {metaTags.description && (
                <meta name='description' content={metaTags.description} />
            )}
            {metaTags.description && (
                <meta property='og:description' content={metaTags.description} />
            )}
            {metaTags.description && (
                <meta name='twitter:description' content={metaTags.description} />
            )}
            {metaTags.image && <meta property='og:image' content={metaTags.image} />}
            {metaTags.image && <meta name='twitter:image' content={metaTags.image} />}
        </Head>
    ) : null;
}

export default Seo;
